import * as React from 'react';
import { ProfileContainer } from '../../containers';

const ProfilePage = () => <ProfileContainer />;

export default ProfilePage;
